import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {EnkelGruppeModell, GruppeMedlemListeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MedlemRedigerKomponent} from "../../komponenter/medlem-rediger/medlem-rediger";

export type MedlemRedigerDialogRespons = boolean;

export interface DialogParametre {
    medlem: GruppeMedlemListeModell;
    gruppe: EnkelGruppeModell;
}

@Component({
    selector: 'medlem-rediger-dialog',
    templateUrl: './medlem-rediger-dialog.html',
    styleUrl: './medlem-rediger-dialog.scss',
    host: { 'class': 'e2e-medlem-rediger-dialog' },
    imports: [
        MatDialogModule,
        MedlemRedigerKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemRedigerDialogKomponent {

    static vis(dialog: MatDialog, medlem: GruppeMedlemListeModell, gruppe: EnkelGruppeModell): MatDialogRef<MedlemRedigerDialogKomponent, MedlemRedigerDialogRespons> {
        return dialog.open(MedlemRedigerDialogKomponent, {
            data: {medlem, gruppe} as DialogParametre,
            disableClose: true,
            ariaLabelledBy: 'medlem-rediger-dialog-tittel',
            maxWidth: '900px',
            width: '100%'
        });
    }

    medlem: GruppeMedlemListeModell;
    gruppe: EnkelGruppeModell;

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                public dialogRef: MatDialogRef<MedlemRedigerDialogKomponent, MedlemRedigerDialogRespons>) {
        // dialog er konf med disableClose:true for å unngå utilsiktet lukking ved klikk utenfor, lytter ikke til ESC for lukking - må trykke avbryt. Denne gui har flere dialoger (feks roller). esc vil da lukke alle dialoger.
        // lyttTilEsc(() => this.avbryt());
        this.medlem = parametre.medlem;
        this.gruppe = parametre.gruppe;
    }

    vedLagret() {
        this.dialogRef.close(true);
    }

    avbryt() {
        this.dialogRef.close(false);
    }
}
